import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthenticationResponseDto } from '../models/auth.model';
import { AcceptInviteRequestDto, CompanyInviteMetadataDto } from '../models/invite.model';

/**
 * Public company-invite API (PublicInviteController). getMetadata prikaže
 * podatke poziva; accept kreira račun u firmi i vraća isti
 * AuthenticationResponse kao login (+ HttpOnly refresh cookie →
 * withCredentials:true, konzistentno s AuthApiService).
 */
@Injectable({ providedIn: 'root' })
export class InviteApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl;

  getMetadata(token: string): Observable<CompanyInviteMetadataDto> {
    return this.http.get<CompanyInviteMetadataDto>(
      `${this.apiUrl}/public/invite/${token}`,
    );
  }

  accept(token: string, body: AcceptInviteRequestDto): Observable<AuthenticationResponseDto> {
    return this.http.post<AuthenticationResponseDto>(
      `${this.apiUrl}/public/invite/${token}/accept`,
      body,
      { withCredentials: true },
    );
  }
}
